module.exports = __webpack_public_path__ + "static/media/7ICJ3.7eb84f04.jpg";